// |
// Module      : Type.AnnEquality
// Description : The Type.AnnEquality module enriches the Type.Equality type class with type-level annotation.
//
// The AnnEquality module introduces an enhanced type class known as AnnTypeEquals,
// which extends the original TypeEquals with type-level annotation for added contextual information.
// This type class is used for comparing types at the type level, and it includes a stack annotation
// for additional context.
//
const annTypeEquals = {proof: v => a => a, Coercible0: () => {}};
const proof = dict => dict.proof;
const to = dictAnnTypeEquals => p => dictAnnTypeEquals.proof(p)(a => a);
const from = dictAnnTypeEquals => p => dictAnnTypeEquals.proof(p)(a => a);
export {annTypeEquals, from, proof, to};
